import React from 'react';
import PropTypes from 'prop-types';

import styles from './TruckTease.module.postcss';

function TruckTeaseBadges({ vehicleType, establishedYear }) {
  return (
    <div className={styles.TruckTeaseBadges}>
      <div>
        <img src='/static/images/icons/red-truck.svg' className={styles.TruckTeaseBadges_truckIcon} alt='' width='18' height='19' />
        Food { vehicleType }
      </div>

      { establishedYear && <span className={styles.TruckTeaseBadges_dot}>&bull;</span> }

      { establishedYear &&
        <div>
          <img src='/static/images/icons/truck-est.svg' alt='' width='18' height='19' />
          EST {establishedYear}
        </div>
      }
    </div>
  );
}

TruckTeaseBadges.propTypes = {
  vehicleType: PropTypes.string.isRequired,
  establishedYear: PropTypes.string,
};

export default TruckTeaseBadges;
